import styled from 'styled-components';

export const Container = styled.div`
  .MuiAppBar-root {
    z-index: 1201;
    background-color: #fff;
  }

  .MuiToolbar-root {
    justify-content: space-between;
  }

  #clickhemofilia-logo {
    height: 48px;
    object-fit: contain;
  }

  .title {
    font-size: 16px;
    font-weight: bold;
    /* color: #0384ac; */
    color: #d14b4b;
  }
`;
